var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgMyLight(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "24px",
    height: "24px",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "\u5207\u7247") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "\\u4E00\\u952E\\u751F\\u6210\\u79FB\\u52A8\\u7AEF",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\u6211\\u7684",
    transform: "translate(-271.000000, -731.000000)",
    fill: "#24C6B2",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\u9996\\u9875",
    transform: "translate(271.000000, 731.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14.2497711,12.2483979 C17.1444919,12.2483979 19.4990845,14.6048215 19.4990845,17.4995423 L19.4990845,17.4995423 L19.4990845,18.7497711 C19.4990845,19.9911504 18.490235,21 17.2488557,21 L17.2488557,21 L6.75022887,21 C5.50884956,21 4.5,19.9911504 4.5,18.7497711 L4.5,18.7497711 L4.5,17.4995423 C4.5,14.6048215 6.85459262,12.2483979 9.7493134,12.2483979 L9.7493134,12.2483979 Z M12,3 C14.3472102,3 16.25,4.90278981 16.25,7.25 C16.25,9.59721019 14.3472102,11.5 12,11.5 C9.65278981,11.5 7.75,9.59721019 7.75,7.25 C7.75,4.90278981 9.65278981,3 12,3 Z",
    id: "\\u5F62\\u72B6\\u7ED3\\u5408"
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMyLight);
export default __webpack_public_path__ + "static/media/my_light.aaea185a0f93bfe5447af80b7a550bbb.svg";
export { ForwardRef as ReactComponent };